import React, { useState } from "react";
import { 
    Box, Button, Stack, CircularProgress,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions 
} from "@mui/material"; 

import default_theme from "assets/themes/themes";

const DraftFooterActions = ({
    draft,
    isPublished,
    onEdit,
    onDelete, 
    onUnpublish,
    isDeleting,
}) => {
    // State to control the delete confirmation popup
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
    };

    const handleConfirmDelete = () => {
        onDelete(draft);
        setOpenDeleteDialog(false);
    };

    return (
        <>
            {/* If it's published from the LAP page, hide these action buttons entirely */}
            {!isPublished && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 4,
                    }}
                >
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleDeleteClick}
                            disabled={isDeleting}
                            sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                borderRadius: 2,
                            }}
                        >
                            {isDeleting ? (
                                <>
                                    <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />
                                    Deleting...
                                </>
                            ) : (
                                "Delete Draft"
                            )}
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={() => onEdit(draft)}
                            sx={{
                                textTransform: "none",
                                borderRadius: 2,
                                fontWeight: 600,
                                borderColor: default_theme.palette.other.main,
                                color: default_theme.palette.other.main,
                            }}
                        >
                            Edit Draft
                        </Button>
                    </Stack>
                </Box>
            )}

            {/* DELETE CONFIRMATION DIALOG */}
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle sx={{ fontWeight: "bold", color: "#d32f2f" }}>
                    Delete Draft?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this draft? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={() => setOpenDeleteDialog(false)} sx={{ color: "#667085", fontWeight: 600 }}>
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} variant="contained" color="error" sx={{ fontWeight: 600 }}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DraftFooterActions;